import { Stack } from "@mui/material";
import * as React from "react";
import styled from "styled-components";
import Icon from "src/components/icon";
import gitlabIcon from "src/assets/icons/gitlab-int";
import gitlabSelfManagedIcon from "src/assets/icons/gitlab-selfmanaged-int";
import githubIcon from "src/assets/icons/github-int";
import slackIcon from "src/assets/icons/slack-int";
import googleWorkspaceIcon from "src/assets/icons/google-workspace-int";
import jiraIcon from "src/assets/icons/jira-int";
import microsoftCalendarIcon from "src/assets/icons/microsoft-calendar-int";
import notionIcon from "src/assets/icons/notion-int";
import { IntegrationCategories } from "src/components/template/constants";
import { useActiveIntegrations } from "src/scenes/dashboard/active-integrations-provider";

const Description = styled.p`
    font-size: 11px;
    font-weight: 300;
    padding-bottom: 6px;
    margin: 0;
`;

const SubText = styled.p`
    font-size: 11px;
    font-weight: 300;
    padding-bottom: 6px;
    margin: 0;
    opacity: 0.8;
`;

const DashboardTooltip = ({
    text,
    integrationsNeeded,
}: {
    text: string;
    integrationsNeeded: IntegrationCategories;
}) => {
    const { isIntegrated } = useActiveIntegrations();

    const calculateFill = (tool) => {
        if (tool === "slack") {
            if (isIntegrated.slack === true) return "palette.primary.main";
            return "palette.background.inactiveIcons";
        }
        if (tool === "google") {
            if (isIntegrated.google === true) return "palette.primary.main";
            return "palette.background.inactiveIcons";
        }
        if (tool === "github") {
            if (isIntegrated.github === true) return "palette.primary.main";
            return "palette.background.inactiveIcons";
        }
        if (tool === "gitlab") {
            if (isIntegrated.gitlab === true) return "palette.primary.main";
            return "palette.background.inactiveIcons";
        }
        if (tool === "jira") {
            if (isIntegrated.jira === true) return "palette.primary.main";
            return "palette.background.inactiveIcons";
        }
        if (tool === "notion") {
            if (isIntegrated.notion === true) return "palette.primary.main";
            return "palette.background.inactiveIcons";
        }
        if (tool === "microsoft") {
            if (isIntegrated.microsoft === true) return "palette.primary.main";
            return "palette.background.inactiveIcons";
        }
        return null;
    };
    const showIcons = () => {
        if (integrationsNeeded === IntegrationCategories.fragmentation)
            return (
                <Stack direction="row" spacing={2}>
                    <Icon svg={gitlabIcon} fill={calculateFill("gitlab")} />
                    <Icon svg={gitlabSelfManagedIcon} fill={calculateFill("gitlab")} />
                    <Icon svg={githubIcon} fill={calculateFill("github")} />
                    <Icon svg={slackIcon} fill={calculateFill("slack")} />
                    <Icon svg={googleWorkspaceIcon} fill={calculateFill("google")} />
                    <Icon svg={microsoftCalendarIcon} fill={calculateFill("microsoft")} />
                </Stack>
            );
        if (integrationsNeeded === IntegrationCategories.work)
            return (
                <Stack direction="row" spacing={2}>
                    <Icon svg={gitlabIcon} fill={calculateFill("gitlab")} />
                    <Icon svg={gitlabSelfManagedIcon} fill={calculateFill("gitlab")} />
                    <Icon svg={githubIcon} fill={calculateFill("github")} />
                    <Icon svg={jiraIcon} fill={calculateFill("jira")} />
                    <Icon svg={notionIcon} fill={calculateFill("notion")} />
                </Stack>
            );
        if (integrationsNeeded === IntegrationCategories.git)
            return (
                <Stack direction="row" spacing={2}>
                    <Icon svg={gitlabIcon} fill={calculateFill("gitlab")} />
                    <Icon svg={gitlabSelfManagedIcon} fill={calculateFill("gitlab")} />
                    <Icon svg={githubIcon} fill={calculateFill("github")} />
                </Stack>
            );
        if (integrationsNeeded === IntegrationCategories.collaboration)
            return (
                <Stack direction="row" spacing={2}>
                    <Icon svg={slackIcon} fill={calculateFill("slack")} />
                    <Icon svg={googleWorkspaceIcon} fill={calculateFill("google")} />
                    <Icon svg={microsoftCalendarIcon} fill={calculateFill("microsoft")} />
                </Stack>
            );
        if (integrationsNeeded === IntegrationCategories.meetings) {
            return (
                <Stack direction="row" spacing={2}>
                    <Icon svg={googleWorkspaceIcon} fill={calculateFill("google")} />
                    <Icon svg={microsoftCalendarIcon} fill={calculateFill("microsoft")} />
                </Stack>
            );
        }
        if (integrationsNeeded === IntegrationCategories.slack)
            return <Icon svg={slackIcon} fill={calculateFill("slack")} />;
        if (integrationsNeeded === IntegrationCategories.pm) {
            return (
                <Stack direction="row" spacing={2}>
                    <Icon svg={jiraIcon} fill={calculateFill("jira")} />
                    <Icon svg={notionIcon} fill={calculateFill("notion")} />
                </Stack>
            );
        }
        return null;
    };

    return (
        <Stack direction="column" alignItems="left">
            <Description color="inherit">{text}</Description>
            <Stack
                direction="row"
                spacing={2}
                pt={0.5}
                justifyContent="space-between"
                alignItems="center"
            >
                <SubText color="inherit">Data source</SubText>
                {showIcons()}
            </Stack>
        </Stack>
    );
};
export default DashboardTooltip;
